// eslint-disable-next-line import/prefer-default-export
export const DECIMAL_SCALE = 2;
